module.exports = __webpack_public_path__ + "static/media/minoan_text_02.46ae18a5.jpg";